import type { SVGProps } from 'react';

const Microsoft = (props: SVGProps<SVGSVGElement>) => (
  <svg {...props} fill="none" viewBox="0 0 21 21" xmlns="http://www.w3.org/2000/svg">
    <rect fill="#F25022" height="9.5" width="9.5" x="0.5" y="0.5" />
    <rect fill="#7FBA00" height="9.5" width="9.5" x="11" y="0.5" />
    <rect fill="#00A4EF" height="9.5" width="9.5" x="0.5" y="11" />
    <rect fill="#FFB900" height="9.5" width="9.5" x="11" y="11" />
  </svg>
);

export { Microsoft };
